:root ._dsp-flex{display:flex;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._height-100vh{height:100vh;}
:root ._items-center{align-items:center;}
:root ._justify-center{justify-content:center;}
:root ._gap-t-space-lar3294{gap:var(--t-space-large);}
:root ._maxW-600px{max-width:600px;}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._pr-t-space-med104641{padding-right:var(--t-space-medium);}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._pl-t-space-med104641{padding-left:var(--t-space-medium);}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}